import { createContext } from "react";

export const AuthContext = createContext<{
  user: string | null;
  getMe: ({ fromWeb }: { fromWeb: boolean }) => Promise<void>;
}>({
  user: null,
  getMe: async () => {},
});
